import { gql } from "apollo-angular";

const GET_APTITUDE_SUBCATEGORIES= gql`
query aptitudeSubcategories ($categoryId: Long)
 {
   category(id: $categoryId, childStatus: "ALL") 
   {
      id
      name
      categoryCode
      status
      subcategoryRelationships {
            subcategory {
                id,
                name
            }
        }
    }
}
`;

export default GET_APTITUDE_SUBCATEGORIES;

